import { shortenAddress } from "thirdweb/utils";
import Card from "../Card";
import EthIcon from "@/assets/eth.svg";
import CheckCircle from "@/assets/check-circle.svg";

interface IProps {
  walletAddress: string;
  allocatedSpon: number;
  vestedSpon: number;
  isClaimed: boolean;
}

export const truncateAddress = (
  address: string,
  substringLength: number = 4
): string =>
  address.length <= 8
    ? address
    : `${address.substring(0, substringLength)}...${address.substring(
        address.length - substringLength
      )}`;

const AllocationDetailsCard = ({
  walletAddress,
  allocatedSpon,
  vestedSpon,
  isClaimed,
}: IProps) => {
  const isSingleAmount = allocatedSpon === 0 || vestedSpon === 0;

  return (
    <Card className="!px-0 !py-0 !gap-0 flex-col md:flex-row">
      <div
        className={`grow-0 shrink-0 bg-[#141416] px-8 py-5 md:py-4 flex gap-3 self-stretch items-center justify-center md:justify-start border-b md:border-b-0 md:border-r border-[#2C2C30] text-white ${
          isSingleAmount ? "basis-1/2" : "basis-1/3"
        }`}
      >
        <EthIcon />
        <span className="font-inter text-base leading-6 hidden md:inline">
          {isSingleAmount ? walletAddress : shortenAddress(walletAddress, 8)}
        </span>
        <span className="font-inter text-base leading-6 md:hidden">
          {shortenAddress(walletAddress, 12)}
        </span>
      </div>
      <div
        className={`flex w-full flex-row justify-evenly ${
          isSingleAmount ? "basis-1/2" : "basis-2/3"
        }`}
      >
        <div
          className={`py-5 flex-col gap-2 justify-center items-center ${
            isSingleAmount ? "hidden" : "flex md:pl-8"
          }`}
        >
          <span className="font-gilroy-regular text-sm">Unlocked Reward</span>
          <span className="font-gilroy-bold text-[17px] leading-6 flex items-center gap-1">
            {Number(allocatedSpon.toFixed(2))} SPON
            {isClaimed ? (
              <div className="relative group">
                <CheckCircle className="w-4 h-4 cursor-pointer" />
                <div className="absolute -translate-x-1/2 bottom-full -translate-y-1 px-2 py-1 text-xs hidden group-hover:block bg-black text-nowrap border rounded-md border-[#2C2C30]">
                  You have claimed the SPON Reward!
                </div>
              </div>
            ) : null}
          </span>
        </div>
        <div
          className={`py-5 flex-col gap-2 justify-center items-center ${
            isSingleAmount ? "hidden" : "flex"
          }`}
        >
          <span className="font-gilroy-regular text-sm">Locked Reward</span>
          <span className="font-gilroy-bold text-[17px] leading-6">
            {Number(vestedSpon.toFixed(2))} SPON
          </span>
        </div>
        <div
          className={`py-5 flex-col gap-2 justify-center items-center ${
            isSingleAmount ? "flex" : "hidden"
          }`}
        >
          <span className="font-gilroy-regular text-sm">
            {allocatedSpon > 0 ? "Unlocked Reward" : "Locked Reward"}
          </span>
          <span className="font-gilroy-bold text-[17px] leading-6 flex items-center gap-1">
            {Number(
              (allocatedSpon > 0 ? allocatedSpon : vestedSpon).toFixed(2)
            )}{" "}
            SPON
            {isClaimed ? (
              <div className="relative group">
                <CheckCircle className="w-4 h-4 cursor-pointer" />
                <div className="absolute -translate-x-1/2 bottom-full -translate-y-1 px-2 py-1 text-xs hidden group-hover:block bg-black text-nowrap border rounded-md border-[#2C2C30]">
                  You have claimed the SPON Reward!
                </div>
              </div>
            ) : null}
          </span>
        </div>
      </div>
    </Card>
  );
};

export default AllocationDetailsCard;
